import { render, staticRenderFns } from "./UserAuthInvitationDialog.vue?vue&type=template&id=f6bc72bc&scoped=true&"
import script from "./UserAuthInvitationDialog.vue?vue&type=script&lang=js&"
export * from "./UserAuthInvitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bc72bc",
  null
  
)

export default component.exports